import { render, staticRenderFns } from "./SocialMenstrualHistory.vue?vue&type=template&id=b713b45a&scoped=true"
import script from "./SocialMenstrualHistory.vue?vue&type=script&lang=js"
export * from "./SocialMenstrualHistory.vue?vue&type=script&lang=js"
import style0 from "./SocialMenstrualHistory.vue?vue&type=style&index=0&id=b713b45a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b713b45a",
  null
  
)

export default component.exports